/* eslint-disable prefer-regex-literals */
const SanitizeWord = (text: string, keyword: boolean = false) => {
  if (text.length === 0) return '';

  text = text.toLowerCase();
  text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a');
  text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e');
  text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i');
  text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o');
  text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u');
  text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
  text = text.replace(new RegExp('[/]', 'gi'), ' ');

  if (!keyword) return text;

  if (text[0] !== '*') text = `\\b${text}`;
  if (text[text.length - 1] !== '*') text = `${text}\\b`;

  text = text.replace(new RegExp('[*]', 'gi'), '\\w*');
  return text;
};

export default SanitizeWord;
